import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../shared';
import { FileManagerComponent } from './file-manager.component';
import { RouterModule } from '@angular/router';
import { FILE_MANAGER_ROUTES } from './file-manager.route';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild(FILE_MANAGER_ROUTES)
    ],
    declarations: [
        FileManagerComponent
    ]
})
export class FileManagerModule {}
